import React from 'react';

import moment from 'moment';

import { formatToFixedSeparateThousands } from 'Helpers/formatService';

export default function SupplierContractTermMilestonesTable(props) {
    return (
        <div className="tw-relative tw-overflow-hidden tw-border-2 tw-border-grey tw-rounded-lg tw-text-charcoal tw-text-sm">
            <table className="tw-w-full tw-table-auto tw-border-collapse tw-text-left">
                <thead className="tw-bg-blue-25 tw-font-semibold">
                    <tr>
                        <th className="tw-p-4">{$t('Description')}</th>
                        <th className="tw-p-4">{$t('Due Date')}</th>
                        {props.hasAmount && <th className="tw-p-4">{$t('Amount')}</th>}
                    </tr>
                </thead>
                {!props.milestones?.length ? (
                    <tbody>
                        <tr className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
                            <td colSpan="100" className="tw-p-4">
                                <span>{$t('This contract has no milestones')}</span>
                            </td>
                        </tr>
                    </tbody>
                ) : (
                    <tbody>
                        {props.milestones.map((milestone) => (
                            <MilestoneRow key={milestone.id} milestone={milestone} hasAmount={props.hasAmount} />
                        ))}
                    </tbody>
                )}
            </table>
        </div>
    );
}

function MilestoneRow({ milestone, hasAmount }) {
    return (
        <tr className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
            <td className="tw-p-4 tw-border-r-2">{milestone.description}</td>
            <td className="tw-p-4 tw-border-r-2 last:tw-border-r-0">{moment(milestone.due_date).format('YYYY-MM-DD')}</td>
            {hasAmount && <td className="tw-p-4">{formatToFixedSeparateThousands(milestone.amount)}</td>}
        </tr>
    );
}
